import list from '@/views/instances/List'
import useList from '@/views/instances/UseList'
export default function(router) {
  router.push({
    path: '/instances',
    redirect: '/instances/list'
  })

  router.push({
    path: '/instances/list',
    name: 'list',
    component: list
  })

  router.push({
    path: '/instances/useList',
    name: 'useList',
    component: useList
  })
}
